// Un aviso que se va solo a los `ms`. Uno nuevo reemplaza al anterior y
// reinicia la cuenta (antes el timer del primero borraba el segundo antes
// de tiempo); al salir de la pantalla no queda ningún timer colgado.
import { useCallback, useEffect, useRef, useState } from "react";

export function useFlash(defaultMs: number): [string | null, (msg: string, ms?: number) => void] {
  const [notice, setNotice] = useState<string | null>(null);
  const timer = useRef<number | null>(null);
  const flash = useCallback((msg: string, ms = defaultMs) => {
    if (timer.current != null) window.clearTimeout(timer.current);
    setNotice(msg);
    timer.current = window.setTimeout(() => { timer.current = null; setNotice(null); }, ms);
  }, [defaultMs]);
  useEffect(() => () => { if (timer.current != null) window.clearTimeout(timer.current); }, []);
  return [notice, flash];
}
